export const CookieName = "Keycloak_Auth";
export const Config = {
    "url": "https://oauth-stg2.it.auth.gr/auth",
    "realm": "universis",
    "clientId": "mobisis-frontend"
}